// form_hooks
export const INPUT_CHANGE = "INPUT_CHANGE";
export const CHECK_FORM_VALIDITY = "CHECK_FORM_VALIDITY";
export const FETCH_DATA_SUCCESS = "FETCH_DATA_SUCCESS";

export const INCREMENT_VALUE = "INCREMENT_VALUE";
export const DECREMENT_VALUE = "DECREMENT_VALUE";
